import { QueryParamConfigMap } from 'use-query-params';

import { useQueryParams } from './useQueryParams';

type InputOptions = {
  fromField?: string;
  toField?: string;
  fromAndToOptional?: boolean;
};

export const useQueryParamsWithTime = <T extends QueryParamConfigMap>(
  params: T,
  inputOptions: InputOptions = {},
) => {
  return useQueryParams(params, { ...inputOptions, withTime: true });
};
